import React from 'react';
import './Contact.css';

const Contact = () => {
    return (
        <div className="contact-page">
            {/* Hero Section with Form */}
            <section id="quote-form" className="contact-hero">
                <div className="container contact-hero-container">
                    <div className="contact-hero-left">
                        <h1>Request a Custom<br />Machining Quote</h1>
                        <p>
                            Contact Sakthivel Engineering for precision<br />
                            CNC, VMC, drilling, and milling services. Share<br />
                            your component details and our team will<br />
                            respond with a competitive quotation.
                        </p>
                    </div>
                    <div className="contact-hero-right">
                        <div className="quote-form-container">
                            <h2>Get a Machining Quote</h2>
                            <form className="quote-form">
                                <div className="form-row">
                                    <input type="text" placeholder="Your name" />
                                    <input type="email" placeholder="Your email" />
                                </div>
                                <input type="tel" placeholder="Phone number" />
                                <input type="text" placeholder="Part / Drawing Reference" />
                                <input type="text" placeholder="Required Quantity" />
                                <textarea placeholder="Project Details" rows="3"></textarea>
                                <button type="button" className="btn-request">Request Quote</button>
                            </form>
                            <p className="form-disclaimer">
                                Your information will be kept confidential and used only for<br />
                                quotation purposes.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Map Section */}
            <section className="map-section section-padding">
                <div className="container">
                    <div className="map-container">
                        <iframe
                            src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=NO.6,%20VIVEKANANDHA%20STREET,%202nd%20CROSS%20STREET,%20BALAJI%20NAGAR,%20AMBATTUR%20WEST,%20CHENNAI-600%20053&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                            width="100%"
                            height="450"
                            style={{ border: 0, borderRadius: '10px' }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Location Map"
                        ></iframe>
                    </div>
                </div>
            </section>

            {/* Contact Info Cards Section */}
            <section className="contact-info-section pb-80">
                <div className="container">
                    <div className="contact-cards-container">
                        <div className="contact-card">
                            <div className="card-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z" fill="var(--primary)" />
                                </svg>
                            </div>
                            <div className="card-content">
                                <h3>Address</h3>
                                <p>NO.6, VIVEKANANDHA STREET, 2nd CROSS STREET,<br />BALAJI NAGAR, AMBATTUR WEST, CHENNAI-600 053.</p>
                            </div>
                        </div>

                        <div className="contact-card">
                            <div className="card-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM19.6 8.25L12.53 12.67C12.21 12.87 11.79 12.87 11.47 12.67L4.4 8.25C4.15 8.09 4 7.82 4 7.53C4 6.86 4.73 6.46 5.3 6.81L12 11L18.7 6.81C19.27 6.46 20 6.86 20 7.53C20 7.82 19.85 8.09 19.6 8.25Z" fill="var(--primary)" />
                                </svg>
                            </div>
                            <div className="card-content">
                                <h3>Email</h3>
                                <p>sakthivelengg87@gmail.com</p>
                            </div>
                        </div>

                        <div className="contact-card">
                            <div className="card-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.5 1H8.5C7.12 1 6 2.12 6 3.5V20.5C6 21.88 7.12 23 8.5 23H15.5C16.88 23 18 21.88 18 20.5V3.5C18 2.12 16.88 1 15.5 1ZM12 21.25C11.31 21.25 10.75 20.69 10.75 20C10.75 19.31 11.31 18.75 12 18.75C12.69 18.75 13.25 19.31 13.25 20C13.25 20.69 12.69 21.25 12 21.25ZM16 17H8V4H16V17Z" fill="var(--primary)" />
                                </svg>
                            </div>
                            <div className="card-content">
                                <h3>Call Us</h3>
                                <p>+91 - 9113494483</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Contact;
